<template>
    <div class="history-desc">
        <div class="img-main">
            <div class="img-map">
                <el-image
                    v-if="activityTab !== '1'"
                    class="imgDesc-img"
                    :src="historyImg.filePathUrl || historyImg.pathsUrl"
                    fit="fill"
                ></el-image>
            </div>
            <div class="imgDesc-main" v-if="activityTab !== '1'">
                <div class="imgDesc-main-item">
                    <div>{{ $t('chengguan.dailypatrol.captureTime') }}：</div>
                    <div class="item-txt">
                        {{ historyImg.createTime || historyImg.eventTime ||'--'}}
                    </div>
                </div>
                |
                <div class="imgDesc-main-item">
                    <div>{{ $t('chengguan.dailypatrol.linkedTask') }}：</div>
                    <el-tooltip :content="historyImg.taskName" placement="top" effect="light">
                        <div class="item-txt">{{ historyImg.taskName ||'--'}}</div>
                    </el-tooltip>
                </div>
                <!-- <div class="imgDesc-main-item">
                    <el-button class="report-btn" type="primary" @click="binReport">上报事件</el-button>
                </div> -->
            </div>
        </div>
        <div class="img-right">
            <div class="img-right-top">

                <div class="img-list">
                    <YScroll style="height: 100%">
                        <template v-if="historyImgList.length > 0">
                            <div
                                class="img-item"
                                :class="imgIndex === index ? 'border' : ''"
                                v-for="(item, index) in historyImgList"
                                :key="index"
                                @click="binImg(item, index)"
                            >
                                <el-image class="img-summary" :src="item.thumbnailUrl" fit="fill"></el-image>
                                <div class="img-time">{{ item.createTime || item.eventTime ||'--'}}</div>
                            </div>
                        </template>

                        <template v-else>
                            <div class="aside-list-empty">
                                {{ $t('chengguan.dailypatrol.noDataAvailable') }}
                            </div>
                        </template>
                    </YScroll>
                </div>
            </div>
        </div>
        <el-dialog
            :visible.sync="reportVisible"
            :append-to-body="true"
            :title="$t('chengguan.dailypatrol.reportEvent')"
            width="1000px"
            :before-close="handleClose"
            custom-class="report-dialog"
        >
            <ReportEvent></ReportEvent>
        </el-dialog>
    </div>
</template>

<script>
import { YScroll } from '@CommonComponent';
import DateUtil from '@/utils/DateUtil.js';
import DatepickerMixin from '@/mixins/datepicker.js';

import MapContainer from '@/components/map/MapContainer/MapContainer.vue';

import ReportEvent from './ReportEvent.vue';

export default {
    mixins: [DatepickerMixin],
    components: {
        MapContainer,
        YScroll,
        ReportEvent,
    },
    props: {
        historyImgList: Array,
    },

    data() {
        return {
            searchForm: {
                queryDate: [],
            },
            activityTab: '',
            imgList: [],
            imgDesc: null,
            imgPoint: [],
            imgIndex: 0,
            showFindPicture: false,
            imgModel: null,
            reportVisible: false,
            historyImg: {},
        };
    },
    watch: {
        historyImgList: {
            handler(newVal) {
                if (newVal.length > 0) {
                    this.activityTab = newVal[0].id;
                    this.imgIndex = 0;
                    this.historyImg = this.historyImgList[0];
                } else {
                    this.historyImg = {};
                }
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        pickerOptions() {
            return {
                ...this.mixinPickerOptions,
                onPick: ({ maxDate, minDate }) => {
                    // 当开始日期选中时，设置限制
                    if (minDate && !maxDate) {
                        const oneYearLater = new Date(minDate);
                        oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
                        this.maxSelectableDate = oneYearLater;
                    } else {
                        this.maxSelectableDate = null;
                    }
                },
                disabledDate: (time) => {
                    const [start, end] = this.dateRange || [];
                    if (start && !end) {
                        const startTime = new Date(start).getTime();
                        const maxTime = new Date(start);
                        maxTime.setFullYear(maxTime.getFullYear() + 1);
                        return time.getTime() > maxTime.getTime();
                    }
                    return false;
                },
            };
        },
    },
    created() {
        const today = DateUtil.getToday();
        const oneMonthAgo = DateUtil.getOneMonthAgo();
        this.searchForm.queryDate = [oneMonthAgo, today];
    },
    mounted() {},
    methods: {
        binReport() {
            this.reportVisible = true;
        },
        handleClose() {
            this.reportVisible = false;
        },

        bindMission(obj, idx) {
            this.missionActivity = idx;
        },
        binImg(val, idx) {
            this.activityTab = val.id;
            this.imgIndex = idx;
            this.historyImg = this.historyImgList[idx];
            console.log('binImg', val, idx);
        },
    },
};
</script>

<style lang="scss" scoped>
.history-desc {
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;
    .img-main {
        flex: 2.5;
        position: relative;
        .img-map {
            height: 100%;
            width: 100%;
        }
        .imgDesc-img {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            border-radius: 2px;
        }
        .imgDesc-main {
            position: absolute;
            bottom: 0;
            left: 0;
            // right: 0;
            width: 100%;
            height: 40px;
            line-height: 40px;
            background: rgba(7, 17, 80, 0.5);
            display: flex;
            justify-content: space-around;

            .imgDesc-main-item {
                display: flex;

                .item-txt {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    -o-text-overflow: ellipsis;
                }
                .report-btn {
                    margin-top: 6px;
                    height: 30px;
                }
            }
        }
    }
    .img-right {
        width: 250px;
        margin-left: 8px;
        .img-right-top {
            height: 82.5vh;
            background-size: 100% 100%;
            overflow: hidden;
            padding: 1px 1px 8px 1px;
            .top-title {
                display: flex;
                justify-content: space-around;
                height: 50px;
                background: #112d7b;
                border-radius: 2px;
                text-align: center;
                line-height: 50px;
                font-size: 18px;
                letter-spacing: 2px;
                border-bottom: 1px solid #1a47a4;
            }
            .img-search {
                width: 248px;
                .img-picker {
                    width: 100% !important;
                    color: white;
                    background: transparent;
                    border: 1px solid #1947a3;
                    ::v-deep.el-range-separator {
                        color: white;
                    }
                    ::v-deep.el-range-input {
                        color: white;
                        background: transparent !important;
                    }
                }
            }
            .img-list {
                height: 78vh;
                // margin-top: 15px;
                overflow: hidden;
                .img-item {
                    height: 190px;
                    width: 248px;
                    margin-bottom: 8px;
                    position: relative;
                    border-radius: 2px;
                    border: #1947a3 1px solid;
                    .img-summary {
                        width: 100%;
                        height: 100%;
                    }
                    .img-time {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        height: 30px;
                        line-height: 30px;
                        text-align: center;
                        background: rgba(7, 17, 80, 0.5);
                    }
                }
                .aside-list-empty {
                    width: 100%;
                    height: 650px;
                    line-height: 650px;
                    text-align: center;
                }
            }
        }
    }
}
.border {
    border: 1px solid #49f0fd !important;
}
</style>
<style lang="scss">
.report-dialog {
    // margin-top: 4vh !important;
    height: 750px;
    background: #071150;
    color: white;
    box-shadow: inset 0px 0px 10px 0px #49f0fd;
    opacity: 1;
    border: 1px solid #49f0fd;
    border-radius: 4px;

    .el-dialog__header {
        border-bottom: 1px #dcdcdc solid;
        padding: 16px;
        border-bottom: #49f0fd 1px solid;
        box-shadow: inset 0px -1px 5px #49f0fd;
        .el-dialog__title,
        .el-dialog__headerbtn .el-icon-close {
            color: #ffffff;
        }
    }
    .el-dialog__body {
        padding: 0 20px 20px 20px;
    }
}
</style>
